module.exports = __webpack_public_path__ + "static/img/Xavier-Va_a.e9365f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Xavier-Va_a.jpg
// module id = C68b
// module chunks = 0